export default {
  placeholder: 'Hae brändiä...',
};
